// extracted by mini-css-extract-plugin
export default {"nav_bar":"navBar_nav_bar__VfKYA","search_box":"navBar_search_box__1-ZNz"};